export default "__VITE_ASSET__B5reg5y8__"